module.exports = __webpack_public_path__ + "img/microneedling-circle-active.2290e452.svg";